$(document).ready(function(){
    $('.block_collection_top_right_box').slick({
        dots: false,
        infinite: true,
        arrows:true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.41016 1.14453L0.40625 6.39453C0.278646 6.52214 0.214844 6.66797 0.214844 6.83203C0.214844 6.99609 0.278646 7.15104 0.40625 7.29688L5.41016 12.5195C5.70182 12.7747 6.01172 12.7839 6.33984 12.5469C6.59505 12.237 6.59505 11.9271 6.33984 11.6172L1.74609 6.80469L6.33984 2.07422C6.59505 1.74609 6.59505 1.4362 6.33984 1.14453C6.01172 0.889323 5.70182 0.889323 5.41016 1.14453Z" fill="black"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.58984 1.14453L6.59375 6.39453C6.72135 6.52214 6.78516 6.66797 6.78516 6.83203C6.78516 6.99609 6.72135 7.15104 6.59375 7.29688L1.58984 12.5195C1.29818 12.7747 0.988281 12.7839 0.660156 12.5469C0.404948 12.237 0.404948 11.9271 0.660156 11.6172L5.25391 6.80469L0.660156 2.07422C0.404948 1.74609 0.404948 1.4362 0.660156 1.14453C0.988281 0.889323 1.29818 0.889323 1.58984 1.14453Z" fill="black"/></svg></button>',
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              slidesToShow: 6,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4,
              centerMode: true,
              centerPadding: '20px',
              initialSlide: 2,
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
              centerMode: true,
              centerPadding: '20px',
              initialSlide: 1,
            }
          }
        ]
      });


        // When the "Read More" button is clicked
        $('.collection_read_more_btn').click(function() {
          // Add 'active' class to show the description box
          $('.block_collection_description_wrapper').addClass('active');
          $('body').addClass('overflow-hidden');
        });
      
        // When the close button is clicked
        $('.block_collection_close_btn').click(function() {
          // Remove 'active' class to hide the description box
          $('.block_collection_description_wrapper').removeClass('active');
          $('body').removeClass('overflow-hidden');

        });
      
        // Close the description when clicking outside of the description box
        $(document).click(function(event) {
          // Check if the clicked element is not inside the .block_collection_description_box
          if (!$(event.target).closest('.block_collection_description_box').length && 
              !$(event.target).is('.collection_read_more_btn')) {
            // Remove the 'active' class
            $('.block_collection_description_wrapper').removeClass('active');
            $('body').removeClass('overflow-hidden');

          }
        });
      
      

});